import React from 'react';

import { Tooltip } from '@material-ui/core';

import { UiButton } from '../../ui/ui-button';

import { LanguageCode } from '../../util/languages';
import { ICON_NAMES, MaterialDesignIcon } from '../../util/material-design-icons';

export const TranslateMessageButton = ({
  className,
  isTranslated,
  loading,
  onTranslateMessageClick,
  onShowOriginalClick,
  languageCode,
  disabled,
  disabledTooltip,
}: {
  className?: string;
  isTranslated: boolean;
  loading?: boolean;
  onTranslateMessageClick: () => void;
  onShowOriginalClick: () => void;
  languageCode?: LanguageCode | null;
  disabled: boolean;
  disabledTooltip: string | null;
}) => {
  // We are not showing the translate button if the message is English
  // If we internationalize the app support other languages for our TE users this logic will need to change
  if (languageCode === 'en') {
    return null;
  }
  return (
    <Tooltip title={disabledTooltip || ''}>
      <span>
        <div className={`${className} u-display-flex u-flexDirection-column u-alignItems-flexEnd`}>
          <UiButton
            className={disabled ? 'u-color-neutral8' : 'u-color-action u-colorHover-actionDark'}
            size="xxs"
            variant="dismiss"
            color="secondary"
            onClick={isTranslated ? onShowOriginalClick : onTranslateMessageClick}
            loading={loading}
            dataCy="translate"
            disabled={disabled}
          >
            {isTranslated && !loading ? 'Show Original' : 'Translate'}
            {disabled ? (
              <MaterialDesignIcon
                className="u-margin-left-xs"
                size="xs"
                iconName={ICON_NAMES.INFO}
              />
            ) : null}
          </UiButton>
        </div>
      </span>
    </Tooltip>
  );
};
